import Vue from 'vue';
import { get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { triggerDataInserted } from 'framework/router/data-inserted-hook';

const Log = Vue.log({ prefixLocation: 'vue-router/route' });
const $title = document.querySelector('head title');
const $description = document.querySelector('head meta[name=description]');

if (!$title || !$description) {
    console.warn(`Warning! Make sure that every page has exactly one title and one description!`);
}

/**
 * Start a fetch request
 * @param {Object} route - A route descriptor object
 * @param {string} route.name  - The route name that is being fetched
 * @param {Object} route.params - All currently active params
 * @param {Object} route.query - The currently active query object
 */
function invokeFetch({ meta, name, params, query }) {
    Log.debug(`[${ name }] - data hook!`);
    return meta.api.fetch({ params, query });
}


/**
 * Vue component
 */
export default {
    data() {
        return {
            routeTransition: '',
            routeData: {},
        };
    },
    computed: {
        ...mapGetters(['router', 'pageType']),
        containers() {
            return get(this, 'routeData.containers', {});
        },
        isLoading() {
            return this.router.isLoading;
        },
    },
    methods: {
        ...mapActions(['setMobileNavigation', 'toggleMapNav', 'setPageType']),
        receiveFetched(fetched) {
            this.updateMeta(fetched.meta || {});
            this.$set(this.$data, 'routeData', fetched);
            this.cleanUpPostFetch();
        },
        cleanUpPreFetch() {
            this.setPageType({ pageType: this.$route.meta.page });
            this.setMobileNavigation({ isOpen: false });
            this.toggleMapNav({ toggle: false });
        },
        cleanUpPostFetch() {
            this.setMobileNavigation({ isOpen: false });
            this.$nextTick(() => {
                triggerDataInserted();
            });
        },
        updateMeta({ title, description }) {
            // NOTE: Update document descriptors on route change
            $title.text = title;
            $description.content = description;
        },
    },
    beforeRouteEnter(to, from, next) {
        const Fetched = invokeFetch(to);

        next(vm => {
            vm.cleanUpPreFetch();
            Fetched.then(vm.receiveFetched);
        });
    },
    beforeRouteUpdate(to, from, next) {
        const Fetched = invokeFetch(to);
        this.cleanUpPreFetch();
        Fetched.then(this.receiveFetched);
        next();
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/route/index.js